// extracted by mini-css-extract-plugin
export default {"wrapper":"negative-feedback-message__wrapper___hOQ7A"};